import styled from 'styled-components';
import { IconWithText } from '../../../stories/molecules';

export const StyledIconWithText = styled(IconWithText)`
  & :first-of-type {
    height: ${({ theme }) => theme.spacing(3)};
    width: ${({ theme }) => theme.spacing(3)};
  }
`;
